import React from 'react';

export default () => (
  <hr className="md-block-hr" />
);
